module.exports = __webpack_public_path__ + "img/def_cha_lokhir_0.a7dada2b.png";